function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "black",
  d: "M39.392 3.776q-1.632 2.464-4.032 4.192 0.032 0.448 0.032 1.024 0 3.264-0.96 6.496-0.928 3.264-2.88 6.24-1.952 2.944-4.64 5.248t-6.432 3.648q-3.776 1.376-8.096 1.376-6.72 0-12.384-3.616 0.992 0.096 1.92 0.096 5.632 0 10.048-3.456-2.624-0.064-4.704-1.632-2.048-1.568-2.848-4 0.768 0.16 1.536 0.16 1.088 0 2.112-0.288-2.784-0.544-4.64-2.784-1.824-2.208-1.824-5.12v-0.128q1.696 0.96 3.648 1.024-1.664-1.088-2.624-2.88-0.96-1.76-0.96-3.84 0-2.176 1.088-4.064 3.040 3.744 7.36 5.952 4.32 2.24 9.28 2.496-0.192-0.896-0.192-1.856 0-3.328 2.368-5.696t5.696-2.368q3.52 0 5.92 2.56 2.72-0.544 5.12-1.984-0.928 2.912-3.552 4.48 2.432-0.288 4.64-1.28z"
});

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    id: "icon-twitter",
    viewBox: "0 0 39 32",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.cfcebd45.svg";
export { ForwardRef as ReactComponent };